import { createContext, useContext } from 'react';
/**
 * The default implementation of {@see VitalTranslationImplementation}.
 * This implementation always returns the fallback string it was passed or
 * `''` if none was provided. For plurals it treats count `1` as singular
 * and every other count as plural.
 */
const defaultImplementation = {
    currentLocale: 'en-US',
    translationByKey: (domain, key, fallback) => fallback ?? '',
    pluralTranslationByKey: (domain, key, count, fallback, pluralFallback) => {
        if (pluralFallback && count !== 1) {
            return pluralFallback ?? fallback ?? '';
        }
        return fallback ?? '';
    },
};
export const VitalTranslationContext = createContext({
    // Set up the default implementation for sites which are English-only (e.g. Circles)
    ...defaultImplementation,
});
export const VitalTranslationProvider = VitalTranslationContext.Provider;
/**
 * A hook which returns helpers for a specific translation domain.
 * NOTE: Must be called from within VitalTranslationContext
 *
 * @param domain the translation domain
 */
export const useTranslation = (domain) => {
    const { currentLocale, translationByKey, pluralTranslationByKey } = useContext(VitalTranslationContext);
    return {
        currentLocale,
        translationByKey: (key, fallback) => translationByKey(domain, key, fallback),
        pluralTanslationByKey: (key, count, fallback, pluralFallback) => pluralTranslationByKey?.(domain, key, count, fallback, pluralFallback) ??
            translationByKey(domain, key, fallback),
    };
};
